import http from './http';

export function sendEmailCode({ email, type = '1' }) {
  return http.postJson('/common/sendEmailCode', {
    email,
    type
  });
}

export function addAddress({ address, nickName, avatar = null, invitationCode = '', email = '', payPwd = '' }) {
  return http.postJson('/user/add/address', {
    address,
    userAddress: address,
    nickName,
    avatar,
    invitationCode,
    email,
    payPwd
  });
}

export function userCheckInvitationCode({ invitationCode }) {
  return http.postJson('/user/checkInvitationCode', {
    invitationCode
  });
}

export function userGetUserInfoByAddress({ address, targetAddress }) {
  return http.postJson('/user/getUserInfoByAddress', {
    address,
    targetAddress
  });
}

export function devicesBindEmailSend({ token, email }) {
  return http.postJson('/devices/bindEmail/send', {
    token,
    email
  });
}


export function emailSend({ token, email, type, label }, config = {}) {
  return http.postJson('/user/email/send', {
    token,
    email,
    type,
    label,
  }, config);
}

export function emailCheck({ token, email, type, code }, config = {}) {
  return http.postJson('/user/email/check', {
    token,
    email,
    type,
    code
  }, config);
}

export function emailRegister(payload, config = {}) {
  return http.postJson('/user/emailRegister', payload, config);
}

export function devicesBindEmail({ token, code }) {
  return http.postJson('/devices/bindEmail', {
    token,
    code
  });
}

export function emailLogin({ token, code, email, label }) {
  return http.postJson('/user/emailLogin', {
    token,
    code,
    email,
    label,
  });
}

export function devicesInfo({ token }, config = {}) {
  return http.postJson('/devices/info', {
    token
  }, config);
}

export function userUpdate({ address, nickName, avatar = null }) {
  return http.postJson('/user/update', {
    address,
    userAddress: address,
    nickName,
    avatar
  });
}

export async function uploadAvatarFile(file, { address } = {}) {
  const fileName = String(file?.name || `avatar-${Date.now()}.png`).trim();
  const formData = new FormData();
  formData.append('file', file, fileName);
  if (address) {
    formData.append('address', address);
  }

  const result = await http.postMultipart('/aws/upload', formData, {
    meta: {
      showLoading: false
    }
  });
  const url = String(result?.urlImage || result?.url || '').trim();
  if (!url) {
    throw new Error('Upload url unavailable');
  }
  return {
    url,
    fileId: result?.fileId ?? null
  };
}

export function payPwdCheck({ payPwd, ...params }) {
  return http.postJson('/user/payPwd/check', {
    payPwd,
    ...params
  }).then((result) => Boolean(result));
}

export function changePayPwd({ payPwd, code, oldPwd }, config = {}) {
  return http.postJson('/user/payPwd/modify', {
    payPwd,
    code,
    oldPwd
  }, config);
}
